export default __webpack_public_path__ + "static/media/emmaM.b03f3a0c.jpg";